import { createFileRoute } from "@tanstack/react-router";
import { NotificationsPage } from "@/components/notifications/notifications-page";

export const Route = createFileRoute("/supervisor/_layout/notifications")({
  component: () => <NotificationsPage audience="SUPERVISOR" />,
});
